var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6875 0.75C13.3984 0.75 14 1.35156 14 2.0625V10.8125C14 11.5508 13.3984 12.125 12.6875 12.125H11.375V13.4375C11.375 14.1758 10.7734 14.75 10.0625 14.75H1.3125C0.574219 14.75 0 14.1758 0 13.4375V4.6875C0 3.97656 0.574219 3.375 1.3125 3.375H2.625V2.0625C2.625 1.35156 3.19922 0.75 3.9375 0.75H12.6875ZM10.5 13.4375V12.125H3.9375C3.19922 12.125 2.625 11.5508 2.625 10.8125V4.25H1.3125C1.06641 4.25 0.875 4.46875 0.875 4.6875V13.4375C0.875 13.6836 1.06641 13.875 1.3125 13.875H10.0625C10.2812 13.875 10.5 13.6836 10.5 13.4375ZM13.125 10.8125V2.0625C13.125 1.84375 12.9062 1.625 12.6875 1.625H3.9375C3.69141 1.625 3.5 1.84375 3.5 2.0625V10.8125C3.5 11.0586 3.69141 11.25 3.9375 11.25H12.6875C12.9062 11.25 13.125 11.0586 13.125 10.8125Z",
    fill: "#797F8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.b224212ad8ea3c5d17acfc29fa72d2ce.svg";
export { ForwardRef as ReactComponent };